import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'CommissionCancellation/Update', method: 'PUT', body: body, token: token })
}
